import { BOOKING_STEP, TRIP_TYPE } from "src/constants";

export const airportUserInputModel = {
  id: "",
  srcLocation: "",
  srcIata: "",
  destLocation: "",
  destIata: "",
};

export const tripModel = {
  id: "",
  srcLocation: { city: "", iata: "", isCity: false, cityIata: "", names: [] },
  destLocation: { city: "", iata: "", isCity: false, cityIata: "", names: [] },
  startDate: "",
  endDate: "",
};

export const searchDataModel = {
  tripType: TRIP_TYPE.roundtrip,
  trips: [tripModel],
  passengers: { adult: 1, child: 0, infant: 0 },
  cabinClass: "",
};

export const passengerModel = {
  id: "",
  main: false,
  ageGroup: "",
  name: "",
  surname: "",
  nationality: "",
  gender: "",
  dob: "",
  skipCheckedBaggage: false,
  committed: false,
};

export const VATDetailsModel = {
  companyName: "",
  companyID: "",
  VATNumber: "",
  registeredAddress: "",
  country: "",
};

export const formState = { isFormIncomplete: false, validationAttempts: 0 };

export const bookingModel = {
  contact: {
    email: "",
    telCode: "",
    tel: "",
    isSubscribedNewsletter: true,
  },
  passengerState: {
    allCommitted: false,
    hasPostCommitChange: false,
  },
  passengers: [],
  billing: {
    isVATRequired: false,
    isCompany: true,
    company: { companyName: "", companyID: "", VATNumber: "", address: "", country: "" },
    person: { name: "", surname: "", address: "", country: "" },
  },
  payment: { type: "", vendor: "" },
  isOffersOptedOut: false,
  travelPackage: {},
  step: {
    [BOOKING_STEP.passengerDetailsForm.id]: { ...formState },
    [BOOKING_STEP.guaranteeSelection.id]: { ...formState },
    [BOOKING_STEP.insuranceSelection.id]: { ...formState },
    [BOOKING_STEP.extraServicesSelection.id]: { ...formState },
    [BOOKING_STEP.seatSelection.id]: { ...formState },
    [BOOKING_STEP.checkoutPage.id]: { ...formState },
  },
  type: "flight",
};

export const hotelBookingModel = {
  hid: "",
  name: "",
  rate: {},
};
